import { db } from "~/db/db";

export const validarProspectsConvertidos = async (query, { apenasProspects = false } = {}) => {
  const temCodigo = (value) => {
    const codigo = String(value ?? "").trim();
    return codigo !== "" && codigo !== "undefined" && codigo !== "0";
  };

  const ids = await query.clone().primaryKeys();
  const clientes = await db.cliente.bulkGet(ids);
  const solicitacoes = await db.solicitacoes.toArray();
  const idsOcultos = new Set();

  clientes.forEach(c => {
    if (c && temCodigo(c.codigo)) idsOcultos.add(String(c.id));
  });
  solicitacoes.forEach(s => {
    if (s.clienteId != null && Number(s.statusSolicitacaoId) !== 3) 
      idsOcultos.add(String(s.clienteId));
  });

  return query.filter(c =>
    (apenasProspects && c.clienteProspect !== 1) ||
    (!temCodigo(c.codigo) && !idsOcultos.has(String(c.id)))
  );
};

